// const assertIsArrayOfObjects<{ label: string; value: string; }>(selected);

import { isObject } from 'underscore';

export function assertReactSelectOptions<T>(data: unknown): asserts data is Array<T> {
  if (!Array.isArray(data)) {
    throw new Error(`Array required, received ${JSON.stringify(data)}`);
  }
  data.forEach((item) => {
    if (!isObject(item)) {
      throw new Error(`Object required, received ${JSON.stringify(item)}`);
    }
    if (typeof item.label !== 'string') {
      throw new Error(`String required, received ${JSON.stringify(item.label)}`);
    }
    if (typeof item.value !== 'string') {
      throw new Error(`String required, received ${JSON.stringify(item.value)}`);
    }
  });
}
